export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://desa-api-servicios.superdesalud.gob.cl"

export const ORIGEN = process.env.REACT_APP_SITE_ORIGEN || "desa-tramites"

//export const ORIGEN = "localhost"

export const URL_CU = process.env.REACT_APP_URL_CU || "https://desa-auth.superdesalud.gob.cl/api/v1/urclave/" + ORIGEN

export const API_AUTH = process.env.REACT_APP_API_AUTH || 'https://desa-auth.superdesalud.gob.cl/api/v1/';

export const SITE_URL = process.env.REACT_APP_SITE_URL || 'localhost:3000';

export const URL_LOOUT_CLAVE_UNICA = 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout';

export const siteUrl= process.env.REACT_APP_SITE_URL_2 || "https://desa-tramites.superdesalud.gob.cl/"

export const TIPO_USR='?type=c'